import React from 'react';

import { Badge } from '@rbilabs/universal-components';
import { StyleSheet, View } from 'react-native';

import Picture from 'components/picture';
import { t } from 'state/intl/translations';

import type { OfferListItemProps } from '../types';

export type OfferBadgesProps = Pick<
  OfferListItemProps,
  'promoCodeLabel' | 'serviceModeText' | 'serviceModeStyle'
> & {
  showWalmartBadge?: boolean;
  walmartBadgeImage?: any;
};

export const OfferBadges = ({
  showWalmartBadge,
  walmartBadgeImage,
  promoCodeLabel,
  serviceModeText,
  serviceModeStyle,
}: OfferBadgesProps) => {
  return (
    <View style={styles.badgesContainer}>
      {showWalmartBadge && (
        <View style={[styles.walmartBadgeContainer, styles.badgeRightMargin]}>
          <Picture height="$6" image={walmartBadgeImage} alt={t('walmartOfferBadgeAlt')} />
        </View>
      )}
      {promoCodeLabel && (
        <View style={styles.badgeRightMargin}>
          <Badge variant="default-outline" iconName="offer">
            {promoCodeLabel}
          </Badge>
        </View>
      )}
      {serviceModeText && (
        <Badge variant={serviceModeStyle ?? 'default-solid'}>{serviceModeText}</Badge>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  badgesContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  badgeRightMargin: {
    marginRight: 8, // $2
  },
  walmartBadgeContainer: {
    display: 'flex',
    alignItems: 'center',
    height: 24, // $6
    width: 64, // $16
  },
});
